import { FRONTENDGETORDERS, COUNTRY, GETINDUSTRYNESTLIST, GETLOOKUPCODE, GETSERVICE, GETSUBSCRIPTION, LOGIN,LOGOUT, AUTHLOGIN, LOGINREDIRECT, GETACCOUNT, DESIGNATEADMIN, CHANGEACCOUNTSTATUS, ADDACCOUNT, UPDATEACCOUNT, CONTACT, GETCONTACT, TOSUB, REGIS_CHECK, FAQ, SENDLETTER, LETTERTOKEN, GETCATEGORYLIST } from 'api/constant'
import { request } from 'api/request'
import { JsonRequest } from 'api/JsonRequest'

const POST = 'POST'
const GET = 'GET'

// *** MARKET PLACE ***
const MARKET_PLACE = 'MARKET_PLACE'
const APIEndpoints = {
    TENANT: 'Tenant',
    TENANTACCOUNT: 'TenantAccount',
    TENANTINDUSTRY: 'TenantIndustry'
  }
// Tenant Account
// Login
export const login = (payload) => request({
  url: `${APIEndpoints.TENANTACCOUNT}/Login`,
  method: POST,
  data: payload,
  type: LOGIN,
  scope: MARKET_PLACE,
  auth: false
})

export const logout = (payload) => request({
  url: `/Auth/Logout`,
  method: POST,
  data: payload,
  type: LOGOUT,
  scope: MARKET_PLACE,
  auth: true
})

export const GetCheckAccount = (payload) => request({
  url: `/Check/CheckAccount`,
  method: GET,
  params: payload,
  type: REGIS_CHECK,
  scope: MARKET_PLACE,
  auth: false
})

export const GetCheckVat = (payload) => request({
  url: `/Check/CheckVat`,
  method: GET,
  params: payload,
  type: REGIS_CHECK,
  scope: MARKET_PLACE,
  auth: false
})

export const GetCheckDuns = (payload) => request({
  url: `/Check/CheckDuns`,
  method: GET,
  params: payload,
  type: REGIS_CHECK,
  scope: MARKET_PLACE,
  auth: false
})

export const GetLoginRedirect = (payload) => request({
  url: `/Auth/AuthLogin`,
  method: GET,
  params: payload,
  type: LOGINREDIRECT,
  scope: MARKET_PLACE,
  auth: false
})

export const AuthLogin = (payload) => request({
  url: `/Auth/ClientTokenAuthCode`,
  method: POST,
  data: payload,
  type: AUTHLOGIN,
  scope: MARKET_PLACE,
  auth: false
})

// ChangePassword
export const ChangePassword = (payload) => request({
  url: `/Auth/ChangePassword`,
  method: POST,
  data: payload,
  type: LOGIN,
  scope: MARKET_PLACE,
  auth: false
})

// Tenant
// Register
export const register = (payload) => request({
  url: `${APIEndpoints.TENANT}/Register`,
  method: POST,
  data: payload,
  type: LOGIN,
  scope: MARKET_PLACE,
  auth: false
})

// TenantProfile
export const getProfile = (payload) => request({
  url: `${APIEndpoints.TENANT}/GetProfile`,
  method: POST,
  data: payload,
  type: LOGIN,
  scope: MARKET_PLACE,
  auth: true
})

export const getFAQ = (payload) => request({
  url: `/FAQ/GetFAQs`,
  method: POST,
  data: payload,
  type: FAQ,
  scope: MARKET_PLACE,
  auth: false
})

export const TenantUpdate = (payload) => request({
  url: `${APIEndpoints.TENANT}/Update`,
  method: POST,
  data: payload,
  type: LOGIN,
  scope: MARKET_PLACE,
  auth: true
})

// GetSubscriptions
export const GetSubscriptions = (payload) => request({
  url: `/Subscription/GetSubscriptions`,
  method: POST,
  data: payload,
  type: GETSUBSCRIPTION,
  scope: MARKET_PLACE,
  auth: true
})

// export const guestGetService = (payload) => request({
//   url: `/Service/GuestGetService`,
//   method: POST,
//   data: payload,
//   type: GETSUBSCRIPTION,
//   scope: MARKET_PLACE,
//   auth: false
// })

export const guestGetService = (payload) => JsonRequest({
  url: `/GuestGetService.json`,
  method: POST,
  data: payload,
  type: 'GuestGetService',
  scope: MARKET_PLACE,
  auth: false
})

// export const guestGetServicev2 = (payload) => request({
//   url: `/Service/GuestGetServiceV2`,
//   method: POST,
//   data: payload,
//   type: "GuestGetServiceV2",
//   scope: MARKET_PLACE,
//   auth: false
// })
export const guestGetServicev2 = (payload) => JsonRequest({
  url: `/GuestGetServiceV2.json`,
  method: POST,
  data: payload,
  type: "GuestGetServiceV2",
  scope: MARKET_PLACE,
  auth: false
})

export const guestGetSubscriptions = (payload) => request({
  url: `/Subscription/GuestGetSubscriptions`,
  method: POST,
  data: payload,
  type: GETSUBSCRIPTION,
  scope: MARKET_PLACE,
  auth: false
})

// *** ADMIN ***
const ADMIN = 'ADMIN'
const AdminEndpoints = {
  INDUSTRY: 'Industry',
  ORDER:'Order',
  LOOKUPCODE: 'LookupCode',
  SUBSCRIPTION: 'Subscription',
  SERVICE: 'Service'
}
// Industry
// GetNestList
export const getIndustryNestList = () => request({
  url: `${APIEndpoints.TENANTINDUSTRY}/GetNestList`,
  method: GET,
  type: GETINDUSTRYNESTLIST,
  scope: MARKET_PLACE,
  auth: false
})
// Preorder
export const frontendGetPreorder = (payload) => request({
  url: `PreOrder`,
  method: GET,
  params: payload,
  type: FRONTENDGETORDERS,
  scope: MARKET_PLACE,
  auth: true
})
// Order
// FrontendGetOrders
export const frontendGetOrders = (payload) => request({
  url: `${AdminEndpoints.ORDER}/FrontendGetOrders`,
  method: POST,
  data: payload,
  type: FRONTENDGETORDERS,
  scope: MARKET_PLACE,
  auth: true
})
// LookupCode
// GetLookupCode
export const getLookupCode = (payload) => request({
  url: `${AdminEndpoints.LOOKUPCODE}/GetLookupCode`,
  method: POST,
  data: payload,
  type: GETLOOKUPCODE,
  scope: MARKET_PLACE,
  auth: true
})
// Service
// GetService
export const GetService = (payload) => request({
  url: `${AdminEndpoints.SERVICE}/FrontendGetServices`,
  method: POST,
  data: payload,
  type: GETSERVICE,
  scope: ADMIN,
  auth: false
})
// Subscription

export const frontendGetSubscriptions = (payload) => request({
  url: `${AdminEndpoints.SUBSCRIPTION}/FrontendGetSubscriptions`,
  method: POST,
  data: payload,
  type: GETSUBSCRIPTION,
  scope: MARKET_PLACE,
  auth: false
})

export const getCountry = (payload) => request({
  url: `/Country/GetList`,
  method: GET,
  params: payload,
  type: COUNTRY,
  scope: MARKET_PLACE,
  auth: false
})


// getAccount
export const getAccount = (payload) => request({
  url: `${APIEndpoints.TENANTACCOUNT}/QueryTenantAccountsOfTenant`,
  method: 'POST',
  data: payload,
  type: GETACCOUNT,
  scope: MARKET_PLACE,
  auth: true
})

// getCompanyScale
export const getCompanyScale = () => request({
  url: `/LookupCode/CompanyScale`,
  method: GET,
  type: GETACCOUNT,
  scope: MARKET_PLACE,
  auth: false
})

// // designateAdmin
export const designateAdmin = (payload) => request({
  url: `${APIEndpoints.TENANTACCOUNT}/DesignateAdmin`,
  method: 'POST',
  data: payload,
  type: DESIGNATEADMIN,
  scope: MARKET_PLACE,
  auth: true
})

export const changeAccountStatus = (payload) => request({
  url: `${APIEndpoints.TENANTACCOUNT}/${ADMIN}/ChangeAccountStatus`,
  method: 'POST',
  data: payload,
  type: CHANGEACCOUNTSTATUS,
  scope: MARKET_PLACE,
  auth: true
})

export const addAccount = (payload) => request({
  url: `${APIEndpoints.TENANTACCOUNT}/AddTenantAccount`,
  method: 'POST',
  data: payload,
  type: ADDACCOUNT,
  scope: MARKET_PLACE,
  auth: true
})

export const updateAccount = (payload) => request({
  url: `${APIEndpoints.TENANTACCOUNT}/User/UpdateProfile`,
  method: 'POST',
  data: payload,
  type: UPDATEACCOUNT,
  scope: MARKET_PLACE,
  auth: true
})

export const getUserAccount = (payload) => request({
  url: `/TenantAccount/GetTenantAccount`,
  method: 'POST',
  data: payload,
  type: GETACCOUNT,
  scope: MARKET_PLACE,
  auth: true
})

export const getContactUs = (payload) => request({
  url: `/MailLog/ContactUs/Info`,
  method: GET,
  params: payload,
  type: GETCONTACT,
  scope: MARKET_PLACE,
  auth: false
})

export const sendContact = (payload) => request({
  url: `/MailLog/ContactUs`,
  method: 'POST',
  data: payload,
  type: CONTACT,
  scope: MARKET_PLACE,
  auth: true
})

export const toSubscription = (payload) => request({
  url: `/Subscription/for_isv`,
  method: 'POST',
  data: payload,
  type: TOSUB,
  scope: MARKET_PLACE,
  auth: true
})

export const sendLetter = (payload) => request({
  url: `/TenantAccount/SendLetterToken`,
  method: 'POST',
  data: payload,
  type: SENDLETTER,
  scope: MARKET_PLACE,
  auth: false
})

export const LetterToken = (payload) => request({
  url: `/TenantAccount/ValidateLetterToken`,
  method: 'POST',
  data: payload,
  type: LETTERTOKEN,
  scope: MARKET_PLACE,
  auth: false
})

// export const getCategoryList = () => request({
//   url: `/Category/Category`,
//   method: 'GET',
//   type: GETCATEGORYLIST,
//   scope: MARKET_PLACE,
//   auth: false
// })
export const getCategoryList = () => JsonRequest({
  url: '/Category.json',
  method: 'GET',
  type: GETCATEGORYLIST,
  scope: MARKET_PLACE,
  auth: false
})

// export const getCategoryService = (payload) => request({
//   url: `/Service/Category`,
//   method: 'GET',
//   params: payload,
//   type: GETCATEGORYLIST,
//   scope: MARKET_PLACE,
//   auth: false
// })
//Service_Category
export const getCategoryService = (payload) => JsonRequest({
  url: `/Service_Category.json`,
  method: 'GET',
  params: payload,
  type: 'SEARCHCATEGORY',
  scope: MARKET_PLACE,
  auth: false
})

// export const getChoiceService = (payload) => request({
//   url: `/Service/Choice`,
//   method: 'GET',
//   data: payload,
//   type: "GETSERVICE",
//   scope: MARKET_PLACE,
//   auth: false
// })
export const getChoiceService = () => JsonRequest({
  url: '/Choice.json',
  method: 'GET',
  type: "GETSERVICE",
  scope: MARKET_PLACE,
  auth: false
})

export const newSubscription = (payload) => request({
  url: `/Subscription/new`,
  method: 'POST',
  data: payload,
  type: "NEWSERVICE",
  scope: MARKET_PLACE,
  auth: true
})

export const getTenantAccount = (payload) => request({
  url: `TenantAccount/TenantAccountsOfTenant`,
  method: 'GET',
  params: payload,
  type: "GETTENANTACCOUNT",
  scope: MARKET_PLACE,
  auth: false
})

export const preorderCreate = (payload) => request({
  url: `preorder/create`,
  method: 'POST',
  data: payload,
  type: "NEWSERVICE",
  scope: MARKET_PLACE,
  auth: true
})

export const ActionLog = (payload) => request({
  url: `/ActionLog/ActionLog`,
  method: 'POST',
  type: "GETSERVICE",
  data: payload,
  scope: MARKET_PLACE,
  auth: true
})

export const refreshToken = (payload) => request({
  url: '/Auth/RefreshToken',
  method: 'POST',
  type: "GETSERVICE",
  data: payload,
  scope: MARKET_PLACE,
  auth: false
})